module.exports = __webpack_public_path__ + "img/geofisica_3-4_2304.1271eb75.webp";